<div class="left-filler"></div>
<div class="text">
  <ng-container *ngTemplateOutlet="template"></ng-container>
</div>
<div class="right-filler">
  <div class="close-container" (click)="cancel.next()">
    <svg-icon [applyCss]="true" src="assets/images/close.svg"></svg-icon>
  </div>
</div>
